import React, { useEffect } from 'react';
import amplifyconfig from './amplifyconfiguration.json';

/**
 * Email Confirmation Component
 *
 * Silently confirms the user's email and redirects to the Mytheresa confirmation page.
 * No UI is displayed during the confirmation process.
 */
function ConfirmEmail() {
  useEffect(() => {
    const confirmEmail = async () => {
      // Get token from URL query parameters
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');

      if (!token) {
        console.error('No confirmation token provided');
        // Redirect anyway even if no token
        window.location.href = 'https://www.mytheresa.com/to/service/confirm';
        return;
      }

      try {
        // Get API endpoint from amplify configuration
        const apiEndpoint = amplifyconfig.custom?.API?.RegistrationAPI?.endpoint
          || amplifyconfig.API?.REST?.RegistrationAPI?.endpoint;

        if (!apiEndpoint) {
          throw new Error('API endpoint not configured');
        }

        // Make direct HTTP request to Lambda Function URL to confirm email
        const response = await fetch(`${apiEndpoint}/confirm?token=${encodeURIComponent(token)}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();

        // Log result for debugging but don't show UI
        if (data.success) {
          console.log('Email confirmed successfully');
        } else {
          console.error('Confirmation failed:', data.error);
        }
      } catch (err) {
        console.error('Confirmation error:', err);
      }

      // Always redirect to Mytheresa confirmation page after confirmation attempt
      window.location.href = 'https://www.mytheresa.com/to/service/confirm';
    };

    confirmEmail();
  }, []);

  // Return null to render nothing while confirming
  return null;
}

export default ConfirmEmail;
